export const WAGE_JURISDICTION_LEVELS = [
  'federal',
  'state',
  'county',
  'place',
] as const

export type WageJurisdictionLevel = (typeof WAGE_JURISDICTION_LEVELS)[number]

export type WageCoverageScope = 'full' | 'unincorporated_only'

export type WageJurisdiction = {
  id: number
  level: WageJurisdictionLevel
  name: string
  stateCode: string | null
  countyFips?: string | null
  placeGeoid?: string | null
}

export type WageJurisdictions = WageJurisdiction[]

export type ActiveRule = {
  id: number
  effectiveStart: string
  effectiveEnd: string | null
  coverageScope: WageCoverageScope
}

export type WageJurisdictionDetail = WageJurisdiction & {
  rules: ActiveRule[]
}

export type WageRate = {
  id: number
  hourlyRateCents: number
  note: string | null
  isEnabled: boolean
}

export type WageRule = {
  id: number
  effectiveStart: string
  effectiveEnd: string | null
  coverageScope: WageCoverageScope
  reference: string | null
  jurisdictionIds: number[]
  jurisdictions: WageJurisdiction[]
  rates: WageRate[]
  placeExclusions: string[]
}

export type WageRules = WageRule[]
